// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ErVX3","btnn":"Card_btnn__YzRw7"};